export enum ChatgptProductFieldType {
  Title = "title",
  Description = "description",
  Link = "link",
  ProductCategory = "product_category",
  Condition = "condition",
  Brand = "brand",
  Material = "material",
  Length = "length",
  Width = "width",
  Height = "height",
  Weight = "weight",
  AgeGroup = "age_group",
}
